import { TENANT_UUID_KEY } from './tenant-uuid';

const SESSION_API_KEY = 'session-api-base-url';

const SESSION_KEYS = [
  'bearer-token',
  'landlord-bearer-token',
  'landlord-refresh-token',
  'tenant-refresh-token',
  'is-authenticated',
  'impersonated',
  'has-accepted-terms',
  'has-tenant-access',
  'force-tenant',
  TENANT_UUID_KEY,
];

export const forgetSessionOfOtherApi = () => {
  const currentApi = import.meta.env.VITE_API_BASE_URL;
  const sessionApi = localStorage.getItem(SESSION_API_KEY);

  if (sessionApi && sessionApi !== currentApi) {
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  }

  localStorage.setItem(SESSION_API_KEY, currentApi);
};
